import config from 'constants/config'
import { TIMELY_ENABLED_REGIONS } from 'constants/config/region'

export const DEFAULT_TIMELY_LINK = 'https://bookings.gettimely.com/luxuryescapes/book?uri=https%3A%2F%2Fbook.gettimely.com%2FBooking%2FLocation%2F211694%3Fmobile%3DTrue%26params%3D%25253fclient-login%25253dtrue'

export function getTimelyLink(): string {
  return config.TIMELY_LINK || DEFAULT_TIMELY_LINK
}

function shouldRenderTimely(region: string): boolean {
  // should be shown only for AU as we have physical store only in AU
  // LE only
  return config.BRAND === 'luxuryescapes' && TIMELY_ENABLED_REGIONS.includes(region)
}

export default shouldRenderTimely
